import React from "react";
import {Page} from "../../../components/page/page";
import styles from "./personal-reading.module.css";
import Image from "../../../images/couple.png";

const PersonalReadingPage = () => {
    const buttonStyles = {
        backgroundColor: "rgb(255, 209, 40)",
        border: "1px solid rgb(255, 209, 40)",
        color: "#000000",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
        position: "absolute",
        bottom: "30px",
        width: "90%",
        zIndex: "5",
        maxWidth: "500px",
        boxSizing: "border-box",
        left: "20px",
        right: "20px"
    };

    const headerStyles = {
        backgroundColor: "transparent",
    }

    return (
        <div className={styles.container_page}>
            <Page title={["Your personal reading will show you ", <span>a future filled with love & happiness.</span>]}
                  nextPageLink="../relationship-expectations" buttonStyles={buttonStyles} currentStep="5"
                  headerStyles={headerStyles} isWhiteLogo={true} isWhiteButton={true}>
                <p className={styles.text}>
                    You don’t need to change a thing — we’ll guide you along the path that’s already unfolding. ✨
                </p>
                <img className={styles.couple_image} src={Image} alt=""/>
            </Page>
        </div>
    );
}

export {PersonalReadingPage};